export const createGoToUrlWithPreservedQueries = (gotoUrl: string) => {
    const currentUrl = new URL(window.location.href);
    const currentParams = currentUrl.searchParams;
    const newUrl = new URL(gotoUrl);

    currentParams.forEach((value, key) => {
        if (!newUrl.searchParams.has(key)) {
            newUrl.searchParams.append(key, value);
        }
    });

    return {
        url: newUrl.toString(),
        searchParams: currentParams,
    };
};
